// Round only chart tick marks; never alter the underlying financial amounts.
export function mobileChartScale(values) {
    const valid = values.filter(Number.isFinite);
    const rawHigh = Math.max(0, ...valid);
    const rawLow = Math.min(0, ...valid);
    if (rawHigh === rawLow) return { high: 0, low: 0, ticks: [0] };
    const roughStep = (rawHigh - rawLow) / 4;
    const magnitude = 10 ** Math.floor(Math.log10(roughStep));
    const ratio = roughStep / magnitude;
    const factor = ratio <= 1 ? 1 : ratio <= 2 ? 2 : ratio <= 2.5 ? 2.5 : ratio <= 5 ? 5 : 10;
    const step = Math.max(1, factor * magnitude);
    const high = Math.ceil(rawHigh / step) * step;
    const low = Math.floor(rawLow / step) * step;
    const ticks = [];
    // The rounded scale spans at most six intervals. Compute from an index to avoid drift.
    const count = Math.round((high - low) / step);
    for (let index = 0; index <= count; index++) {
        const value = high - index * step;
        ticks.push(Object.is(value, -0) ? 0 : value);
    }
    return { high, low, ticks };
}
